/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */
import {
  homeLatestSearch,
  motorLatestSearch,
  motorQuotesContacted
} from '../../constants/apiRequest/requestConstants/endpoints';
import { makeRequest } from '../../helpers/makeApiRequest';

export const getLatestQuotes = async (
  pageSize,
  pageNumber,
  forHome,
  props = {}
) => {
  const journey = forHome ? homeLatestSearch : motorLatestSearch;
  return await makeRequest({
    method: 'GET',
    url: `${journey}?page=${pageNumber}&size=${pageSize}&sort=created_date,DESC`,
    history: props.history
  });
};

export const updateContactedStatus = async (
  quoteReference,
  contacted,
  forHome
) => {
  const journey = forHome ? '/' : motorQuotesContacted;
  return await makeRequest({
    method: 'PUT',
    url: `${journey}`,
    payload: {
      quote_reference: quoteReference,
      contacted: contacted
    }
  });
};
